/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * You can import directly from @lit/react now.
 * @deprecated
 */
export {
  /**
   * You can import directly from @lit/react now.
   * @deprecated
   */
  createComponent,
  /**
   * You can import directly from @lit/react now.
   * @deprecated
   */
  type EventName,
  /**
   * You can import directly from @lit/react now.
   * @deprecated
   */
  type ReactWebComponent,
  /**
   * You can import directly from @lit/react now.
   * @deprecated
   */
  type WebComponentProps,
} from '@lit/react';
